import {
  disablePolygonDelivery,
  enablePolygonDelivery,
  getDeliveryCoverage,
  getOwnDeliveryCoverage
} from './thunk';

export const builderGetDeliveryCoverage = (builder: any) => {
  builder.addCase(getDeliveryCoverage.pending, (state: any) => {
    state.loadingDeliveryCoverage = true;
    state.deliveryCoverageExpressError = '';
  });
  builder.addCase(getDeliveryCoverage.rejected, (state: any, action: any) => {
    state.loadingDeliveryCoverage = false;
    state.deliveryCoverageError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
    if (action.meta.arg?.delivery_method === 'express') {
      state.deliveryCoverageExpressError = state.deliveryCoverageError;
    }
  });
  builder.addCase(getDeliveryCoverage.fulfilled, (state: any, action: any) => {
    state.loadingDeliveryCoverage = false;
    state.deliveryCoverageError = '';
    const deliveryMethod = action.meta.arg?.delivery_method;

    if (deliveryMethod === 'express') {
      if (action.payload.data.polygon.length === 0) {
        state.deliveryCoverageExpress = undefined;
        state.deliveryCoverageExpressError = 'سرویس پیک اسنپ برای شما فعال نیست.';
      } else {
        state.deliveryCoverageExpress = action.payload;
        state.deliveryCoverageExpressError = '';
      }
    }
  });
};

const mergeOwnDeliveryCoverage = (own: any, vendorFleet: any) => {
  const getPolygons = (coverage: any) =>
    Array.isArray(coverage?.data?.polygon) ? coverage.data.polygon : [];

  const ownPolygons = getPolygons(own);
  const vendorFleetPolygons = getPolygons(vendorFleet);
  const mergedPolygons = [...ownPolygons, ...vendorFleetPolygons];

  if (mergedPolygons.length === 0) {
    return null;
  }

  const base = ownPolygons.length > 0 ? own : vendorFleet;

  return {
    ...base,
    data: {
      ...base.data,
      polygon: mergedPolygons
    }
  };
};

export const builderGetOwnDeliveryCoverage = (builder: any) => {
  builder.addCase(getOwnDeliveryCoverage.pending, (state: any) => {
    state.loadingDeliveryCoverage = true;
    state.deliveryCoverageOwn = undefined;
    state.deliveryCoverageOwnError = '';
  });
  builder.addCase(getOwnDeliveryCoverage.rejected, (state: any) => {
    state.loadingDeliveryCoverage = false;
    state.deliveryCoverageOwn = undefined;
    state.deliveryCoverageOwnError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(getOwnDeliveryCoverage.fulfilled, (state: any, action: any) => {
    state.loadingDeliveryCoverage = false;
    const merged = mergeOwnDeliveryCoverage(action.payload.own, action.payload.vendorFleet);

    if (!merged) {
      state.deliveryCoverageOwn = undefined;
      state.deliveryCoverageOwnError = 'سرویس پیک فروشگاه برای شما فعال نیست.';
    } else {
      state.deliveryCoverageOwn = merged;
      state.deliveryCoverageOwnError = '';
    }
  });
};

export const builderEnablePolygonDelivery = (builder: any) => {
  builder.addCase(enablePolygonDelivery.pending, (state: any) => {
    state.enablingPolygonDelivery = true;
    state.enablePolygonDeliveryError = '';
    state.enablePolygonDeliveryResponse = undefined;
  });
  builder.addCase(enablePolygonDelivery.rejected, (state: any) => {
    state.enablingPolygonDelivery = false;
    state.enablePolygonDeliveryError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(enablePolygonDelivery.fulfilled, (state: any, action: any) => {
    state.enablingPolygonDelivery = false;
    state.enablePolygonDeliveryError = '';
    state.enablePolygonDeliveryResponse = action.payload;
  });
};

export const builderDisablePolygonDelivery = (builder: any) => {
  builder.addCase(disablePolygonDelivery.pending, (state: any) => {
    state.disablingPolygonDelivery = true;
    state.disablePolygonDeliveryError = '';
    state.disablePolygonDeliveryResponse = undefined;
  });
  builder.addCase(disablePolygonDelivery.rejected, (state: any) => {
    state.disablingPolygonDelivery = false;
    state.disablePolygonDeliveryError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
  builder.addCase(disablePolygonDelivery.fulfilled, (state: any, action: any) => {
    state.disablingPolygonDelivery = false;
    state.disablePolygonDeliveryError = '';
    state.disablePolygonDeliveryResponse = action.payload;
  });
};
